function calculateDistance(element, pageX, pageY) {
  let left = element.offset().left;
  return Math.abs(pageX - left);
}







$(document).on("mousemove", "span.product", function (e) {
  let prevBtn = $(this).find(".imgStart");
  let nextBtn = $(this).find(".imgEnd");
  let width = $(this).width();
  let self = $(this);
  prevBtnOpacity = Math.floor(
    ((width - calculateDistance(prevBtn, e.pageX, e.pageY)) * 100) / width
  );
  nextBtnOpacity = Math.floor(
    ((width - calculateDistance(nextBtn, e.pageX, e.pageY)) * 100) / width
  );
  self[0].style.setProperty("--left-opacity", prevBtnOpacity.toString());
  self[0].style.setProperty("--right-opacity", nextBtnOpacity.toString());
});

$(document).ready(function () {
  const facetsForm = $("#FacetFiltersForm,#FacetFiltersFormMobile");

  facetsForm.on("input", function () {
    $("#shopify-section-collection span.product .slick").slick("unslick");
    $("#shopify-section-collection span.product .slick.primary a + a img").addClass("hidden");
  });

  facetsForm.on("rendered", function () {
    $("#shopify-section-collection span.product .slick").each(function () {
      $(this).slick({
        infinite: true,
        dots: true,
        appendDots: $(this).parent().find(".slick-dots-element")
      });
    });
    $("#shopify-section-collection span.product .slick.primary img").removeClass(
      "hidden"
    );
  });


  //iterate over all slick classses
  $("#shopify-section-collection span.product .slick").each(function () {
    $(this).slick({
      infinite: true,
      dots: true,
      appendDots: $(this).parent().find(".slick-dots-element")
    });
  });

  $("#shopify-section-collection span.product .slick.primary img").removeClass(
    "hidden"
  );

});
